import {BasicConfigStructure} from "./basic-config-structure.model";

export class ConfigStructure extends BasicConfigStructure {

  template: string;
  nestedConfig: ConfigStructure[] = [];
  isLink: boolean;
  allMatches = false;
  elseConfig: ConfigStructure;
  skipNewLine = false;
  list = false;

  constructor(attr: { name?: string, show?: boolean, translation: string, template: string, isLink?: boolean, nestedConfigs?: ConfigStructure[], limitNestedIteration?: number, allMatches?: boolean, elseConfig?: ConfigStructure, skipNewLine?:boolean, list?:boolean}) {
    super(attr);
    this.template = attr.template;
    if (attr.nestedConfigs) {
      attr.nestedConfigs.forEach(nestedConfig => {
        this.nestedConfig.push(new ConfigStructure(nestedConfig));
      });
    }
    if (attr.isLink) {
      this.isLink = attr.isLink;
    } else {
      this.isLink = false;
    }
    if (attr.allMatches) {
      this.allMatches = attr.allMatches;
    }
    this.elseConfig = attr.elseConfig;
    if (attr.skipNewLine){
      this.skipNewLine = attr.skipNewLine;
    }
    if (attr.list){
      this.list = attr.list;
    }
  }
}
